"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTradeActivitiesV2 = void 0;
const types_1 = require("../types");
const getTradeActivitiesV2 = ({ bondTradeTransactions }) => {
    const tradeActivities = bondTradeTransactions.map((tradeTransaction) => {
        return {
            timestamp: tradeTransaction.soldAt,
            signature: tradeTransaction.publicKey,
            pair: tradeTransaction.bondOffer,
            orderType: types_1.OrderType.Sell,
            pairType: types_1.PairType.TokenForNFT,
            nftMint: tradeTransaction.fbondTokenMint,
            solAmount: tradeTransaction.solAmount + tradeTransaction.feeAmount,
            feeAmount: tradeTransaction.feeAmount,
            amountOfTokens: tradeTransaction.amountOfBonds,
            userMaker: tradeTransaction.user,
            userTaker: tradeTransaction.seller,
            isDirectSell: tradeTransaction.isDirectSell,
            isV2: true,
        };
    });
    return tradeActivities;
};
exports.getTradeActivitiesV2 = getTradeActivitiesV2;
